import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "mx-1",
  style: {"font-size":"1.1rem"}
}

import { Interfaces } from "@/types/tickets";
import Table from "@/components/TablePaginated.vue";
import { coreApi } from "@/conection";
import {
	InterfacesColor,
	InterfaceId,
	TicketsStatus,
	TicketsStatusColor,
} from "@/types/tickets";
import { CallDataModule } from "@/store/modules/CallData";
import { AppModule } from "@/store/modules/app";
import { IColumn } from "@/types/components";
import { ITicket } from "@/types/tickets";
import { computed, onMounted, ref } from "vue";
import { DateTime } from "ts-luxon";
import { IPagination } from "../omni";
import { TableColumnCtx } from "element-plus";
import { useRouter } from "vue-router";
import { AuthModule } from "@/store/modules/Auth";

// => Data

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const th: IColumn[] = [
	{
		text: "Canal",
		value: "channel",
		width: 250,
	},
	{
		text: "Agente",
		value: "agent",
		width: 250,
	},
	{
		text: "Nombre usuario",
		value: "client",
		width: 250,
	},
	{
		text: "Identificadores",
		value: "identification",
		width: 150,
	},
	{
		text: "Estado",
		value: "status",
		width: 150,
	},
	{
		text: "Inicio",
		value: "createdAt",
		width: 180,
	},
	{
		text: "Finalización",
		value: "states",
		width: 180,
	},
	{
		text: "Tipificación",
		value: "tipificacion",
		default: "Sin tipificación",
		width: 180,
	},
	{
		text: "Subtipificación",
		value: "subtipificacion",
		default: "Sin subtipificación",
		width: 180,
	},
	{
		text: "Comentario",
		value: "comentario",
		default: "-",
		width: 180,
	},
];
const router = useRouter();
const loading = ref(false);
const td = ref<ITicket[]>([]);

// => Computed
const paginate = computed(() => AppModule.pagination.ticketsHistory);

// => Methods
async function onRowClick({
	row: ticket,
}: {
	row: ITicket;
	col: TableColumnCtx<any>;
	e: PointerEvent;
}) {
	AppModule.setShowNavbar(true);
	if (
		ticket.status === "closed" ||
		(ticket.status === "claimed" &&
			ticket.agent.every(a => a._id !== AuthModule.user?.id))
	)
		router.push({
			name: "Messages",
			params: { option: "overview" },
			query: {
				ticket: ticket._id,
				client: ticket.client[0]._id,
				limit: AppModule.pagination.ticketsHistory?.perPage,
				page: AppModule.pagination.ticketsHistory?.currentPage,
			},
		});
	else if (ticket.bot)
		router.push({
			name: "Messages",
			params: { option: "bot" },
			query: { ticket: ticket._id },
		});
	else if (ticket.status === "open")
		router.push({
			name: "Messages",
			params: { option: "unassigned" },
			query: { ticket: ticket._id },
		});
	else if (ticket.status === "claimed")
		router.push({
			name: "Messages",
			params: { option: "assigned" },
			query: { ticket: ticket._id },
		});

	// console.log("rowclick: ", row);
}
async function fetchData(pag?: IPagination) {
	const response = await coreApi.post<{
		page: number;
		limit: number;
		success: boolean;
		tickets: ITicket[];
		total: number;
	}>(`/api/ticket/client/${CallDataModule.user?._id}`, {
		page: pag?.page ?? paginate.value?.currentPage ?? 1,
		limit: pag?.limit ?? paginate.value?.perPage ?? 15,
		filter: pag?.filter,
	});
	td.value = response.data.tickets;
	AppModule.setPagination({
		ticketsHistory: {
			currentPage: response.data.page,
			perPage: response.data.limit,
			perPageOptions: [15, 25, 50, 75],
			total: response.data.total,
		},
	});
}
onMounted(fetchData);

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(Table, {
    tableData: { td: td.value, th: th, totalDocs: 0 },
    load: loading.value,
    tittle: "Registro de tickets",
    tittlebtn: "Actualizar",
    disabled: false,
    btn: true,
    filter: true,
    cardClass: "m-1",
    tableLayout: "fixed",
    pagination: _unref(paginate),
    "table-props": {
			rowClassName: 'can-hover',
		},
    onUpdateData: _cache[0] || (_cache[0] = ({ pagination }) => fetchData(pagination)),
    onRowClick: onRowClick,
    onUpdateInputData: _cache[1] || (_cache[1] = ({ pagination }) => fetchData(pagination))
  }, {
    channel: _withCtx(({ row }: { row: ITicket }) => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("i", {
          class: _normalizeClass(`${_unref(Interfaces)[row.channel.interface as InterfaceId]} text-${_unref(InterfacesColor)[row.channel.interface as InterfaceId]}`)
        }, null, 2)
      ]),
      _createTextVNode(" " + _toDisplayString(row.channel.name), 1)
    ]),
    agent: _withCtx(({ row }: { row: ITicket }) => [
      _createTextVNode(_toDisplayString(row.agent.length > 0
					? row.agent.map(a => a.name + ` [${a.auth.code}]`).join(" - ")
					: "Sin agente asignado"), 1)
    ]),
    client: _withCtx(({ row }: { row: ITicket }) => [
      _createTextVNode(_toDisplayString(row.client.reduce(
					(acc, curr) => acc + (curr.customer.full_name ?? curr.customer.name),
					""
				)), 1)
    ]),
    identification: _withCtx(({ row }: { row: ITicket }) => [
      _createTextVNode(_toDisplayString(row.client.reduce(
					(acc, curr) => acc + curr.identification.join(","),
					""
				)), 1)
    ]),
    status: _withCtx(({ row }: { row: ITicket }) => [
      _createVNode(_component_el_tag, {
        type: 
					_unref(TicketsStatusColor)[
						row.bot && row.status !== 'closed' ? 'bot' : row.status
					]
				
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(TicketsStatus)[row.bot && row.status !== "closed" ? "bot" : row.status]), 1)
        ]),
        _: 2
      }, 1032, ["type"])
    ]),
    createdAt: _withCtx(({ row }: { row: ITicket }) => [
      _createTextVNode(_toDisplayString(_unref(DateTime).fromISO(row.createdAt.toString()).toFormat(
					"dd/MM/yyyy hh:mm a"
				)), 1)
    ]),
    states: _withCtx(({ row }: { row: ITicket }) => [
      _createTextVNode(_toDisplayString(row.states
					? row.states.closed_at
						? _unref(DateTime).fromISO(row.states.closed_at).toFormat(
							"dd/MM/yyyy hh:mm a"
						)
						: row.states.claimed_at
							? "En progreso"
							: "Pendiente"
					: "-"), 1)
    ]),
    _: 1
  }, 8, ["tableData", "load", "pagination"]))
}
}

})